@if (introduction) {
  <div class="mb10" [innerHTML]="introduction.text"></div>
}
@for (checkbox of checkboxes; track checkbox.text) {
  @if (checkbox.text) {
    <label class="im:checkbox-label">
      <input
        #checkbox
        class="im:checkbox-input"
        type="checkbox"
        (change)="checkboxValueChanged()"
      />
      <span class="im:body"><span [innerHTML]="checkbox.text"></span></span>
    </label>
  }
}
@if (conclusion) {
  <div [innerHTML]="conclusion.text"></div>
}
